<template>
    <div class="employee-tab-inner">          
        <b-overlay :show="showoverlay" rounded="sm">
            <div class="" id="">
                <b-tabs tab-class="nav-item-trustee" content-class="mt-4" nav-wrapper-class="trustee-nav-wrapper mt-4">
                    <template v-slot:tabs-start>
                        <b-nav-item disabled href="#" class="trustee-nav-first-wrapper">
                            <div class="trustee-nav-first">
                                <div class="trustee-nav-head">Deregistration from Provident Fund</div>
                                <div class="trustee-nav-subhead">Deregistration from Provident Fund and Settlements.</div>
                            </div>
                        </b-nav-item>
                    </template> 
                    <b-tab lazy active title-item-class="trustee-nav wi-three">
                       
                       <template #title>
                           <div class="trustee-report-title">
                               <img v-bind:src="$api_url+'/images/table_chart.svg'" class="trustee-tab-icon"/>
                               <div class="text">View Leavers</div>
                           </div>
                           <div class="trustee-report-intro">
                            List of all Leavers from Provident Fund.
                           </div>
                       </template>
                       <div class="trustee-tab-wrapper">
                            <pf-leaver-list-front  :pageurl="this.$api_url"></pf-leaver-list-front>
                       </div>
                   
                    </b-tab>   
                    <b-tab lazy title-item-class="trustee-nav wi-three">
                       
                       <template #title>
                           <div class="trustee-report-title">
                               <img v-bind:src="$api_url+'/images/table_chart.svg'" class="trustee-tab-icon"/>
                               <div class="text">Awaiting Settlement</div>
                           </div>
                           <div class="trustee-report-intro">
                            View all Leavers awaiting Settlement.
                           </div>
                       </template>
                       <div class="trustee-tab-wrapper">
                        <pf-awating-settlement-list-front  :pageurl="this.$api_url"></pf-awating-settlement-list-front>
                       </div>
                   
                    </b-tab> 
                    <b-tab lazy title-item-class="trustee-nav wi-three">
                       
                       <template #title>
                           <div class="trustee-report-title">
                               <img v-bind:src="$api_url+'/images/table_chart.svg'" class="trustee-tab-icon"/>
                               <div class="text">Settlement Applications Awaiting Approval</div>
                           </div>
                           <div class="trustee-report-intro">
                            View all Applications awaiting Approval for Settlement.
                           </div>
                       </template>
                       <div class="trustee-tab-wrapper">
                        <pf-settlement-awating-approval-list-front  :pageurl="this.$api_url"></pf-settlement-awating-approval-list-front>
                       </div>
                   
                    </b-tab> 

                    <b-tab lazy title-item-class="trustee-nav wi-three">
                       
                       <template #title>
                           <div class="trustee-report-title">
                               <img v-bind:src="$api_url+'/images/table_chart.svg'" class="trustee-tab-icon"/>
                               <div class="text">Settlement List</div>
                           </div>
                           <div class="trustee-report-intro">
                            View all Disbursed Settlement Applications.
                           </div>
                       </template>
                       <div class="trustee-tab-wrapper">
                            <pf-settlement-list-front  :pageurl="this.$api_url"></pf-settlement-list-front>
                       </div>
                   
                    </b-tab> 
        
                    <!-- Form ends here -->
                </b-tabs>
            </div>
        </b-overlay>
    </div>
</template>
 
<script>
    
    export default{
        
        props: ['flg','pageurl'],
   
        data(){            
            
            return {
                showoverlay:true,

            }
        },
        methods:{

            

        },
        created: function(){
            this.showoverlay = false;
        }
    }
</script>

<style>
.settlement_field_trz {
	margin-bottom: 0;
	width: 80%;
	margin: 0 0 0 auto;
}
.settlement_field_trz input {
	opacity: 1 !important;
	text-align: right;
}
.showoverlay_settle .b-overlay {
	height: 100%;
} 
</style>
